import { render, staticRenderFns } from "./AccountUserChangePasswordDialog.vue?vue&type=template&id=4dd63770&scoped=true&"
import script from "./AccountUserChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./AccountUserChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd63770",
  null
  
)

export default component.exports